// Should stay in sync with userManagement/constants/ValidationErrorCodes.js

export const VALIDATION_ERROR_CODES = {
  USER_LICENSE_ALREADY_FREE: 'USER_LICENSE_ALREADY_FREE',
  MOVE_TO_FREE_NOT_ALLOWED: 'MOVE_TO_FREE_NOT_ALLOWED',
  NO_AVAILABLE_LICENSES: 'NO_AVAILABLE_LICENSES',
  FUTURE_ASSIGNED_EVENTS: 'FUTURE_ASSIGNED_EVENTS',
  FUTURE_INVITED_EVENTS: 'FUTURE_INVITED_EVENTS'
};
